<!-- 🌐 Top Navbar -->
<div
  class="top-nav d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-white"
>
  <div class="hamburger d-lg-none" (click)="toggleMobileSidebar()">
    <span></span>
    <span></span>
    <span></span>
  </div>

  <!-- Logo -->
  <!-- <div
    class="logo d-flex align-items-center"
    style="min-width: 180px; max-width: 420px; overflow: hidden"
  >
    <ng-container *ngIf="shouldShowSchoolBrand; else nishwikLogo">
      <ng-container *ngIf="schoolBrandLogo && !schoolBrandLogoFailed; else schoolInitialLogo">
        <img
          [src]="schoolBrandLogo"
          [alt]="schoolBrandName || 'School Logo'"
          class="img-fluid"
          style="
            height: 40px;
            width: 40px;
            object-fit: contain;
            border-radius: 8px;
            background: #ffffff;
          "
          (error)="onSchoolBrandLogoError()"
        />
      </ng-container>

      <ng-template #schoolInitialLogo>
        <div
          class="d-flex align-items-center justify-content-center fw-bold"
          style="
            height: 40px;
            width: 40px;
            min-width: 40px;
            border-radius: 50%;
            background: #8b0050;
            color: #ffffff;
            font-size: 18px;
          "
        >
          {{ schoolBrandInitial }}
        </div>
      </ng-template>

      <span
        class="ms-2 fw-bold text-truncate"
        style="
          color: #011044;
          font-size: 18px;
          line-height: 20px;
          max-width: 330px;
          display: inline-block;
        "
        [title]="schoolBrandName"
      >
        {{ schoolBrandName }}
      </span>
    </ng-container>

    <ng-template #nishwikLogo>
      <img
        src="assets/images/Logo.svg"
        alt="Logo"
        class="img-fluid"
        style="height: 40px"
      />
    </ng-template>
  </div> -->


  <!-- Logo -->
<div
  class="logo d-flex align-items-center"
  style="min-width: 180px; max-width: 420px; overflow: hidden"
>
  <!-- School: logo + school name -->
  <ng-container *ngIf="shouldShowSchoolBrand; else checkHospitalLogo">
    <ng-container
      *ngIf="
        schoolBrandLogo && !schoolBrandLogoFailed;
        else schoolInitialLogo
      "
    >
      <img
        [src]="schoolBrandLogo"
        [alt]="schoolBrandName || 'School Logo'"
        class="img-fluid"
        style="
          height: 40px;
          width: 40px;
          min-width: 40px;
          object-fit: contain;
          border-radius: 8px;
          background: #ffffff;
        "
        (error)="onSchoolBrandLogoError()"
      />
    </ng-container>

    <ng-template #schoolInitialLogo>
      <div
        class="d-flex align-items-center justify-content-center fw-bold"
        style="
          height: 40px;
          width: 40px;
          min-width: 40px;
          border-radius: 50%;
          background: #8b0050;
          color: #ffffff;
          font-size: 18px;
        "
      >
        {{ schoolBrandInitial }}
      </div>
    </ng-template>

    <span
      class="ms-2 fw-bold text-truncate"
      style="
        color: #011044;
        font-size: 18px;
        line-height: 20px;
        max-width: 330px;
        display: inline-block;
      "
      [title]="schoolBrandName"
    >
      {{ schoolBrandName }}
    </span>
  </ng-container>

  <!-- Hospital: logo only -->
<ng-template #checkHospitalLogo>
  <ng-container
    *ngIf="shouldShowHospitalBrand; else nishwikLogo"
  >
    <ng-container
      *ngIf="
        hospitalBrandLogo && !hospitalBrandLogoFailed;
        else hospitalInitialLogo
      "
    >
      <img
        [src]="hospitalBrandLogo"
        [alt]="hospitalBrandName || 'Hospital Logo'"
        class="img-fluid"
        style="
          height: 40px;
          width: 40px;
          min-width: 40px;
          object-fit: contain;
          border-radius: 8px;
          background: #ffffff;
        "
        (error)="onHospitalBrandLogoError()"
      />
    </ng-container>

    <ng-template #hospitalInitialLogo>
      <div
        class="d-flex align-items-center justify-content-center fw-bold"
        style="
          height: 40px;
          width: 40px;
          min-width: 40px;
          border-radius: 50%;
          background: #007c91;
          color: #ffffff;
          font-size: 18px;
        "
      >
        {{ hospitalBrandInitial }}
      </div>
    </ng-template>

    <span
      class="ms-2 fw-bold text-truncate"
      style="
        color: #011044;
        font-size: 18px;
        line-height: 20px;
        max-width: 330px;
        display: inline-block;
      "
      [title]="hospitalBrandName"
    >
      {{ hospitalBrandName }}
    </span>
  </ng-container>
</ng-template>

  <!-- Default Nishwik logo -->
  <ng-template #nishwikLogo>
    <img
      src="assets/images/Logo.svg"
      alt="Nishwik Logo"
      class="img-fluid"
      style="height: 40px"
    />
  </ng-template>
</div>

  <!-- Top Icons -->
  <div class="top-icons d-flex align-items-center gap-3">

   <!-- Search box (hidden on mobile) -->
<div
  class="search-box d-none d-md-flex align-items-center px-3 py-1 bg-light rounded-pill position-relative"
  style="min-width: 260px;"
>
  <i class="fas fa-search me-2 text-secondary"></i>

  <input
    type="text"
    class="form-control border-0 bg-transparent p-0"
    placeholder="Search in app..."
    autocomplete="off"
    [value]="headerSearchText"
    (input)="onHeaderSearchInput($event)"
    (focus)="onHeaderSearchFocus()"
    (keydown.escape)="closeHeaderSearch()"
  />

  <button
    *ngIf="headerSearchText"
    type="button"
    class="btn border-0 p-0 ms-2 text-secondary"
    (click)="clearHeaderSearch()"
    aria-label="Clear search"
  >
    <i class="fas fa-times"></i>
  </button>

  <div
    *ngIf="showHeaderSearchResults"
    class="position-absolute bg-white shadow border rounded-3"
    style="
      top: calc(100% + 8px);
      left: 0;
      right: 0;
      min-width: 300px;
      max-height: 320px;
      overflow-y: auto;
      z-index: 1100;
    "
  >
    <ng-container *ngIf="filteredHeaderSearchResults.length > 0; else noHeaderResults">
      <button
        type="button"
        *ngFor="let item of filteredHeaderSearchResults"
        class="btn btn-light w-100 text-start rounded-0 border-bottom px-3 py-2"
        (click)="selectHeaderSearchResult(item)"
      >
        <i
          [class]="item.menuIconUrl || 'fas fa-search'"
          class="me-2"
        ></i>

        {{ item.subRoleName }}
      </button>
    </ng-container>

    <ng-template #noHeaderResults>
      <div class="text-muted text-center p-3">
        No matching pages found.
      </div>
    </ng-template>
  </div>
</div>


    <!-- Chat -->
    <!-- ✅ Fixed: support-action will load only after validated user data is ready -->
    <app-support-action *ngIf="isUserReady"></app-support-action>

    <!-- Support -->
    <!-- <div class="support-icon" title="Support" (click)="openSupport()">
      <i class="fas fa-headset fs-6"></i>
    </div> -->

    <i class="fas fa-bell fs-6" title="Alerts"></i>
    <i
      class="fas fa-cog fs-7"
      title="Settings"
      routerLink="/myaccount/profile"
    ></i>

    <!-- Profile Dropdown -->
    <!-- <div class="position-relative">
      <div class="userProfileWindow" [ngStyle]="{ 'background-color': randomProfileColor }" (click)="toggleDropdown()">
        <img [src]="userInfo.profileImage" alt="profile image" *ngIf="userInfo.profileImage">
         <p>{{ shortUserName }}</p>
      </div>
      <i class="fas fa-user fs-6" title="Profile" (click)="toggleDropdown()" #profileIcon></i>
      <ul class="dropdown-menu dropdown-menu-end mt-2" *ngIf="isDropdownOpen" #dropdownMenu>
        <li><a (click)="logout()">Logout</a></li>
      </ul>
      <div>

      </div>
    </div> -->

    <button class="universal-submit-btn" (click)="logout()">Logout</button>
  </div>
</div>


<!-- ================================================================
     MINIMUM ADDITION:
     ROUTE-BASED MULTI-MODULE CERTIFICATE GENERATOR POPUP
================================================================= -->
<div
  *ngIf="showGenerateCertificatePopup"
  class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
  style="
    z-index: 99999;
    background: rgba(1, 16, 68, 0.56);
    backdrop-filter: blur(4px);
    padding: 20px;
  "
  (click)="closeGenerateCertificatePopup()"
>
  <div
    class="bg-white shadow-lg"
    style="
      width: min(1050px, 96vw);
      max-height: 92vh;
      overflow-y: auto;
      border-radius: 18px;
    "
    (click)="$event.stopPropagation()"
  >
    <!-- Popup Header -->
    <div
      class="d-flex align-items-center justify-content-between"
      style="
        position: sticky;
        top: 0;
        z-index: 5;
        padding: 18px 22px;
        background: #ffffff;
        border-bottom: 1px solid #e8ecf3;
        border-radius: 18px 18px 0 0;
      "
    >
      <div class="d-flex align-items-center">
        <div
          class="d-flex align-items-center justify-content-center me-3"
          style="
            width: 44px;
            height: 44px;
            min-width: 44px;
            border-radius: 12px;
            background: linear-gradient(135deg, #011044, #ba025e);
            color: #ffffff;
          "
        >
          <i class="fas fa-certificate"></i>
        </div>

        <div>
          <h5
            class="m-0"
            style="
              color: #011044;
              font-size: 18px;
              font-weight: 700;
            "
          >
            {{ certificatePopupTitle }}
          </h5>

          <small class="text-muted">
            {{ certificatePopupDescription }}
          </small>
        </div>
      </div>

      <button
        type="button"
        class="btn border-0 d-flex align-items-center justify-content-center"
        style="
          width: 38px;
          height: 38px;
          min-width: 38px;
          padding: 0;
          border-radius: 50%;
          background: #f4f6fa;
          color: #011044;
        "
        [disabled]="isCertificateGenerating"
        (click)="closeGenerateCertificatePopup()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Popup Body -->
    <div
      style="
        padding: 22px;
        background: #f8f9fc;
      "
    >
      <!--
        NO MODULE DROPDOWN.
        Current route automatically decides:
        School / Hospital / Housing Society.
      -->

      <!-- Institution + Template Type -->
      <div
        class="bg-white"
        style="
          padding: 18px;
          margin-bottom: 18px;
          border: 1px solid #e5e9f0;
          border-radius: 14px;
        "
      >
        <div class="row g-3">
          <!-- Dynamic Institution -->
          <div class="col-md-7">
            <label
              class="form-label fw-semibold"
              style="
                color: #011044;
                font-size: 13px;
              "
            >
              Select {{ certificateEntityLabel }}
              <span class="text-danger">*</span>
            </label>

            <div
              *ngIf="isCertificateEntityLoading"
              class="form-control d-flex align-items-center"
              style="
                min-height: 43px;
                border-radius: 9px;
              "
            >
              <span
                class="spinner-border spinner-border-sm me-2"
              ></span>

              Loading {{ certificateEntityLabel }} list...
            </div>

            <select
              *ngIf="!isCertificateEntityLoading"
              class="form-select"
              style="
                min-height: 43px;
                border-color: #dce2ec;
                border-radius: 9px;
                color: #011044;
              "
              [value]="selectedCertificateEntityId"
              (change)="onCertificateEntityChange($event)"
            >
              <option value="0">
                Select {{ certificateEntityLabel }}
              </option>

              <option
                *ngFor="let entity of certificateEntityList"
                [value]="getCertificateEntityValue(entity)"
              >
                {{ getCertificateEntityName(entity) }}
              </option>
            </select>

            <small
              *ngIf="
                !isCertificateEntityLoading &&
                certificateEntityList.length === 0
              "
              class="text-danger d-block mt-1"
            >
              No active/onboarded {{ certificateEntityLabel }} found.
            </small>
          </div>

          <!-- Template Type -->
          <div class="col-md-5">
            <label
              class="form-label fw-semibold"
              style="
                color: #011044;
                font-size: 13px;
              "
            >
              Template Type
              <span class="text-danger">*</span>
            </label>

            <div
              *ngIf="isCertificateTemplateLoading"
              class="form-control d-flex align-items-center"
              style="
                min-height: 43px;
                border-radius: 9px;
              "
            >
              <span
                class="spinner-border spinner-border-sm me-2"
              ></span>

              Loading template types...
            </div>

            <select
              *ngIf="!isCertificateTemplateLoading"
              class="form-select"
              style="
                min-height: 43px;
                border-color: #dce2ec;
                border-radius: 9px;
                color: #011044;
              "
              [value]="certificateTemplateId"
              (change)="onCertificateTemplateChange($event)"
            >
              <option value="">
                Select Template Type
              </option>

              <option
                *ngFor="let templateType of certificateTemplateList"
                [value]="templateType"
              >
                {{ templateType }}
              </option>
            </select>

            <small
              *ngIf="
                !isCertificateTemplateLoading &&
                certificateTemplateList.length === 0
              "
              class="text-danger d-block mt-1"
            >
              No active base PrintMaster template found for
              {{ certificateBaseTemplateIdLabel }}.
            </small>
          </div>
        </div>
      </div>

      <!-- SP Input Fields -->
      <div
        class="bg-white"
        style="
          border: 1px solid #e5e9f0;
          border-radius: 14px;
          overflow: hidden;
          margin-bottom: 18px;
        "
      >
        <div style="padding: 18px">
          <!-- HeaderHtml -->
          <div class="mb-4">
            <div
              class="d-flex align-items-center justify-content-between mb-2"
            >
              <label
                class="m-0 fw-semibold"
                style="
                  color: #011044;
                  font-size: 13px;
                "
              >
                <i
                  class="fas fa-heading me-2"
                  style="color: #ba025e"
                ></i>

                Header HTML
              </label>

              <span
                style="
                  padding: 3px 9px;
                  border-radius: 20px;
                  background: #f4f5f9;
                  color: #7a8190;
                  font-size: 11px;
                "
              >
                @HeaderHtml
              </span>
            </div>

            <textarea
              class="form-control font-monospace"
              rows="6"
              [placeholder]="certificateHeaderPlaceholderForSelectedModule"
              style="
                resize: vertical;
                min-height: 145px;
                border-color: #dce2ec;
                border-radius: 10px;
                background: #fbfcfe;
                color: #252a35;
                font-size: 12px;
                line-height: 1.6;
              "
              [value]="certificateHeaderHtml"
              (input)="
                certificateHeaderHtml = $any($event.target).value;
                generatedCertificateHtml = ''
              "
            ></textarea>
          </div>

          <!-- CustomCss -->
          <div class="mb-4">
            <div
              class="d-flex align-items-center justify-content-between mb-2"
            >
              <label
                class="m-0 fw-semibold"
                style="
                  color: #011044;
                  font-size: 13px;
                "
              >
                <i
                  class="fas fa-paint-brush me-2"
                  style="color: #ba025e"
                ></i>

                Custom CSS
              </label>

              <span
                style="
                  padding: 3px 9px;
                  border-radius: 20px;
                  background: #fff2f8;
                  color: #ba025e;
                  font-size: 11px;
                  font-weight: 600;
                "
              >
                @CustomCss
              </span>
            </div>

            <textarea
              class="form-control font-monospace"
              rows="8"
              [placeholder]="certificateCssPlaceholder"
              style="
                resize: vertical;
                min-height: 185px;
                border: 1px solid #cfd7e4;
                border-radius: 10px;
                background: #ffffff;
                color: #252a35;
                font-size: 12px;
                line-height: 1.6;
              "
              [value]="certificateCustomCss"
              (input)="
                certificateCustomCss = $any($event.target).value;
                generatedCertificateHtml = ''
              "
            ></textarea>
          </div>

          <!-- FooterHtml -->
          <div>
            <div
              class="d-flex align-items-center justify-content-between mb-2"
            >
              <label
                class="m-0 fw-semibold"
                style="
                  color: #011044;
                  font-size: 13px;
                "
              >
                <i
                  class="fas fa-align-center me-2"
                  style="color: #ba025e"
                ></i>

                Footer HTML
              </label>

              <span
                style="
                  padding: 3px 9px;
                  border-radius: 20px;
                  background: #f4f5f9;
                  color: #7a8190;
                  font-size: 11px;
                "
              >
                @FooterHtml
              </span>
            </div>

            <textarea
              class="form-control font-monospace"
              rows="6"
              [placeholder]="certificateFooterPlaceholder"
              style="
                resize: vertical;
                min-height: 145px;
                border-color: #dce2ec;
                border-radius: 10px;
                background: #fbfcfe;
                color: #252a35;
                font-size: 12px;
                line-height: 1.6;
              "
              [value]="certificateFooterHtml"
              (input)="
                certificateFooterHtml = $any($event.target).value;
                generatedCertificateHtml = ''
              "
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Success -->
      <div
        *ngIf="generatedCertificateHtml"
        class="d-flex align-items-center"
        style="
          padding: 13px 15px;
          margin-bottom: 18px;
          border: 1px solid #cce9d9;
          border-radius: 10px;
          background: #edf9f2;
          color: #147344;
          font-size: 13px;
        "
      >
        <i
          class="fas fa-check-circle me-2"
        ></i>

        Certificate generated successfully.
        You can now View or Download it.
      </div>

      <!-- Actions -->
      <div
        class="d-flex flex-wrap align-items-center justify-content-between gap-2"
      >
        <button
          type="button"
          class="btn btn-light"
          style="
            min-width: 90px;
            min-height: 40px;
            border: 1px solid #dce2ec;
            border-radius: 9px;
          "
          [disabled]="isCertificateGenerating"
          (click)="closeGenerateCertificatePopup()"
        >
          Close
        </button>

        <div
          class="d-flex flex-wrap gap-2"
        >
          <button
            type="button"
            class="btn d-flex align-items-center justify-content-center"
            style="
              min-width: 105px;
              min-height: 40px;
              border: 1px solid #011044;
              border-radius: 9px;
              background: #ffffff;
              color: #011044;
              font-size: 13px;
              font-weight: 600;
            "
            [disabled]="
              !generatedCertificateHtml ||
              isCertificateGenerating
            "
            (click)="viewGeneratedSchoolCertificate()"
          >
            <i
              class="fas fa-eye me-2"
            ></i>

            View
          </button>

          <button
            type="button"
            class="btn d-flex align-items-center justify-content-center"
            style="
              min-width: 115px;
              min-height: 40px;
              border: 1px solid #138451;
              border-radius: 9px;
              background: #ffffff;
              color: #138451;
              font-size: 13px;
              font-weight: 600;
            "
            [disabled]="
              !generatedCertificateHtml ||
              isCertificateGenerating
            "
            (click)="downloadGeneratedSchoolCertificate()"
          >
            <i
              class="fas fa-download me-2"
            ></i>

            Download
          </button>

          <button
            type="button"
            class="btn d-flex align-items-center justify-content-center"
            style="
              min-width: 175px;
              min-height: 40px;
              border: none;
              border-radius: 9px;
              background: linear-gradient(135deg, #011044, #ba025e);
              color: #ffffff;
              font-size: 13px;
              font-weight: 600;
              box-shadow: 0 4px 12px rgba(1, 16, 68, 0.15);
            "
            [disabled]="
              isCertificateGenerating ||
              selectedCertificateEntityId <= 0 ||
              !certificateTemplateId
            "
            (click)="generateSchoolCertificate()"
          >
            <ng-container
              *ngIf="
                !isCertificateGenerating;
                else certificateGenerating
              "
            >
              <i
                class="fas fa-certificate me-2"
              ></i>

              Generate Certificate
            </ng-container>

            
            <ng-template
              #certificateGenerating
            >
              <span
                class="spinner-border spinner-border-sm me-2"
              ></span>

              Generating...
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- 🌐 Sidebar + Content -->
<div class="d-flex">
  <!-- Sidebar -->
  <div
    class="sidebar bg-white border-end d-flex flex-column"
    [class.shrinked]="isSidebarCollapsed"
    [class.mobile-open]="isMobileSidebarOpen"
  >
    <!-- Sidebar Menu -->
    <ul
      class="sidebar-menu list-unstyled mb-0 flex-grow-1 overflow-hidden mt-1"
    >
      <div
        id="sidebarMenuAccordion"
        #sidebarMenuScroll
        class="menu-items overflow-auto h-100"
      >
        <li class="menu-item" *ngFor="let parent of parentMenu">
          <a
            class="menu-link d-flex align-items-center py-2 px-2 rounded"
            [routerLink]="getSidebarRouterLink(parent)"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#' + parent.subRoleId"
            [attr.aria-expanded]="isSidebarParentMenuOpen(parent)"
            [attr.aria-controls]="'menu-' + parent.subRoleId"
            (click)="toggleMenu(parent.menuId)"
            [title]="parent.subRoleName"
          >
            <i [class]="parent.menuIconUrl + ' me-2'"></i>
            <span class="menu-text">{{ parent.subRoleName }}</span>
          </a>

          <ul
            class="submenu list-unstyled ps-3 collapse"
            [attr.id]="parent.subRoleId"
            [attr.data-bs-parent]="'#sidebarMenuAccordion'"
           [ngClass]="{
  show: isSidebarParentMenuOpen(parent)
}"
          >
            <li *ngFor="let child of parent.childMenuList">
  <a
    class="submenu-link d-flex align-items-center py-1 px-2 rounded"
    [routerLink]="getSidebarRouterLink(child, parent)"
    [queryParams]="getSidebarRouterLink(child, parent) === '/fee' ? { reset: 'overview' } : null"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="rememberSidebarScrollPosition()"
    [title]="child.subRoleName"
  >
    <i [class]="child.menuIconUrl + ' me-2'"></i>
    <span class="menu-text">{{ child.subRoleName }}</span>
  </a>
</li>
          </ul>
        </li>
      </div>
    </ul>

    <!-- Sidebar Bottom (Always at end) -->
<div class="sidebar-bottom mt-auto">
  <!-- <div *ngIf="showERPIcons" class="pt-3">
    <div class="erp-icons d-flex justify-content-around text-center mb-2">
      <div
        class="icon-item-modern"
        title="CRM"
        (click)="openInNewTab(redirectURL + '/crm/lead-worklist')"
      >
        <div class="icon-circle shadow-lg">
          <i class="bi bi-person-lines-fill"></i>
        </div>
        <div class="fw-semibold text-white label-text">CRM</div>
      </div>

      <div
        class="icon-item-modern"
        title="HRMS"
        (click)="openInNewTab(redirectURL + '/hrms/attendance-muster')"
      >
        <div class="icon-circle shadow-lg">
          <i class="bi bi-people"></i>
        </div>
        <div class="fw-semibold text-white label-text">HRMS</div>
      </div>

      <div
        class="icon-item-modern"
        title="Support Desk"
        (click)="openInNewTab(redirectURL)"
      >
        <div class="icon-circle shadow-lg">
          <i class="bi bi-headset"></i>
        </div>
        <div class="fw-semibold text-white label-text">Support</div>
      </div>
    </div>
  </div> -->

  <!-- ✅ Powered By Nishwik Footer Logo -->
  <div class="powered-by-footer">
    <div class="powered-by-text">Powered by</div>
    <img
      src="assets/images/Logo.svg"
      alt="Nishwik Logo"
      class="powered-by-logo"
    />
  </div>

  <!-- Toggle Button -->
  <div
    class="sidebar-toggle text-center py-2 border-top"
    (click)="toggleSidebar()"
  >
    <i
      class="fas"
      [ngClass]="
        isSidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'
      "
      style="color: white"
    ></i>
  </div>
</div>

  </div>

  <!-- Content -->
  <div class="content flex-grow-1 p-3 position-relative">

    

    <router-outlet></router-outlet>
  </div>
</div>